/* eslint-disable */
import { IPersonalInformation } from 'src/interfaces/personal-info';
import { IBank, IDependent } from 'src/interfaces';
import { IAddresses } from 'src/interfaces/personal-info';
import axios, { AxiosError } from 'axios';
import http from './http';

class PersonalInfoService {
  // Must be refactored. the code is too old.
  static patchPersonalInformation(data: Partial<IPersonalInformation>) {
    return http.patch(`/personal-informations/${data.id}`, {
      ...data,
      address: { secondaryEmail: data.secondaryEmail, phone1: data.phone1, phone2: data.phone2 },
    });
  }

  static getPersonalInformation() {
    return http.get('/personal-informations');
  }

  static getPostalCodes() {
    return http.get('/personal-informations/saved-postal-codes');
  }

  static getSecurityQues(username: string): Promise<any[]> {
    return http
      .get(`/auth/security-questions-ans/${username}`)
      .then(response => response.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static updateSecurityAns(values: any) {
    return http
      .put('/auth/security-question-ans', values)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static postDependent(dep: IDependent, personelNumber: string) {
    return http
      .post(`/personal-informations/dependents/${personelNumber}`, dep)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }
  static updateDependent(dep: IDependent, personelNumber: string) {
    return http
      .put(`/personal-informations/dependents/${dep.id}`, dep)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }
  static deleteDependent(dep: IDependent): Promise<void> {
    return http
      .delete(`/personal-informations/dependents/${dep.id}`)
      .then(response => response.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }
  // In bank module api
  static postBankWithTicket(bankData: IBank, personnelNumber: string) {
    return http
      .post(`/bank-information/create-with-ticket/${personnelNumber}`, bankData)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          throw err;
        }
      });
  }

  static getUserBanksInfo(): Promise<any[]> {
    return http
      .get(`/bank-information/user-banks/`)
      .then(response => response.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static postAddress(address: IAddresses, personelNumber: string) {
    return http
      .post(`/personal-informations/create-address`, address)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static updateAddress(address: IAddresses, personelNumber: string) {
    return http
      .put(`/personal-informations/update-address/${address.id}`, address)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static deleteAddress(address: IAddresses): Promise<void> {
    return http
      .delete(`/personal-informations/delete-address/${address.id}`)
      .then(response => response.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }
}
export default PersonalInfoService;
